import React, { Component, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import Swal from "sweetalert2";
import {
  List,
  Edit,
  Create,
  SimpleForm,
  Toolbar,
  SaveButton,
  TextInput,
  email,
  regex,
  choices,
  Button,
  required,
  minLength,
  maxLength,
  SelectInput,
  Datagrid,
  TextField,
  EditButton,
  DateField,
  Filter,
  Link,
  useRecordContext,
  Pagination
} from "react-admin";
// import { Link } from "react-router-dom";
import Modal from "react-responsive-modal";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
const apiUrl = RUN_TIME_API_ENDPOINT;

export const ListingModal = (props) => {

  const [open, setOpen] = useState(false);
  const record = useRecordContext();
  console.log("record ListingModal",record)
  
  const onSave = (record) => {
    const url = `${apiUrl}/sap_contracts_update_product`;
    const data = {
      status: String(!JSON.parse(record.status)),
      id: record.id,
      ids: record.ids,
      material_number: record.material_number,
      material_description: record.material_description,
      plant_code: record.plant_code,
      name: record.name,
    };
    const options = CommonHeaderOption();
    options.method = "POST";
    options.body = JSON.stringify(data);
    console.log(data);
    Swal.fire({
      text: "Please wait while your request is being processed.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    return fetch(url, options)
      .then((res) => {
        if (res.status === 401) {
          localStorage.removeItem("__state");
          window.location.href = "#/login";
        }
        return res.json();
      })
      .then((json) => {
        console.log("json ===>", json);
        window.location.reload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Unable to process your request at this time. Please try again later.",
        });
        console.log(error);
      });
  };

  const openListingModal = () => {
    setOpen(true);
  };

  const onCloseModal = () => {
    setOpen(false);
  };

  const onToggle = () => {

    console.log("record onToggle",record)
    let settingValue = record.status !== true ? "ON" : "OFF";
    const url = `${apiUrl}/sap_contracts_update_product`;
    Swal.fire({
      text:
        "Are you sure to change the value of " +
        record.material_description +
        " to " +
        settingValue +
        ".",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        onSave(record);
      }
    });
  };

    console.log("props Listing called", props);
    let recordValue = record.status ? "ON" : "OFF";
    let settingValue = record.status !== true ? "ON" : "OFF";
    console.log("provvvvvvvvvvvps", recordValue);
    return (
      <div>
        <div
          className={`toggle-button-container ${
            recordValue === "ON" ? "toggle-button-on" : ""
          }`}
        >
          <label className="switch">
            <input
              type="checkbox"
              checked={recordValue === "ON"}
              onChange={openListingModal}
            />{" "}
            <div></div>
          </label>
          <span className="switch-status">{recordValue}</span>
        </div>
        {open && onToggle()}
      </div>
    );
}

const SettingAuditLogButton = () => {
  const record = useRecordContext();
  console.log("record", record);

  return (
    <Button
      component={Link}
      to={{
        pathname: `/track_logs_history`,
        search: `filter={"id": ${record.ids[0]}}`,
      }}
    >
      <div>
        <p className="view-button">View</p>
      </div>
      {/* <span className="view-button">View</span> */}
    </Button>
  );
};

const PostFilter = (props) => (
  <Filter {...props}>
    <TextInput source="name" label="Plant Name" defaultValue="" />
    <TextInput source="material_number" />
    <TextInput
      source="material_description"
      label="Material Name"
      defaultValue=""
    />
  </Filter>
);

const ProductListPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 50, 100, 150, 200]} {...props} />
);

export const ProductList = (props) => {
  return (
    <React.Fragment>
    <Scrollbars className="scroll-container">
      <List
        {...props}
        filters={<PostFilter />}
        exporter={false}
        pagination={<ProductListPagination />}

      >
        <Datagrid bulkActionButtons={false}>
          <TextField label="Plant Name" source="name" />
          <TextField label="Material Name" source="material_description" />
          <TextField source="material_number" />
          <ListingModal source="status" label="Product Status" />
          <SettingAuditLogButton label="Updated Log" />
        </Datagrid>
      </List>
    </Scrollbars>
    </React.Fragment>
  );
};
